import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import exact from 'prop-types-exact'
import tabStyle from './styles'

const Tab = ({
  children,
  id,
  active,
}) => {
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    // set loaded once only to avoid unmounting lazy-loaded content
    if (active && !loaded) setLoaded(true)
  }, [active])

  return (
    <section
      key={id}
      id={id}
      className={`Tab${active ? ' active' : ''}`}
      role="tabpanel"
      aria-labelledby={`${id}-tab`}
    >
      { (active || loaded) && children }
      <style jsx>{tabStyle}</style>
    </section>
  )
}

Tab.propTypes = exact({
  id: PropTypes.string.isRequired,
  active: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
})

Tab.defaultProps = {
  active: false,
  children: null,
}

export default Tab
